var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search_listing" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", {
          staticClass: "title",
          domProps: { innerHTML: _vm._s(_vm.title) },
        }),
        _vm._v(" "),
        _vm.show_filter === "on" &&
        _vm.paginatedData.length >= 0 &&
        Object.keys(_vm.parsedCategories).length >= 0 &&
        _vm.busy != true
          ? _c("ul", { staticClass: "filter-cats" }, [
              _c(
                "div",
                {
                  staticClass: "sort_banner",
                  class: {
                    "no-filter":
                      _vm.show_filter === "" ||
                      _vm.parsedCategories.length <= 1,
                  },
                },
                [
                  _vm.paginatedData.length < 12
                    ? _c("p", {
                        staticClass: "no-posts",
                        domProps: {
                          innerHTML: _vm._s(
                            "Showing " +
                              _vm.paginatedData.length +
                              " of " +
                              _vm.filteredCategory.length
                          ),
                        },
                      })
                    : _vm.paginatedData.length >= 12
                    ? _c("p", {
                        staticClass: "no-posts",
                        domProps: {
                          innerHTML: _vm._s(
                            "Showing 12" + " of " + _vm.filteredCategory.length
                          ),
                        },
                      })
                    : _vm._e(),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.busy === true
            ? _c(
                "div",
                { staticClass: "overlay" },
                [_c("loading-animation")],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.busy != true && _vm.paginatedData.length != 0
          ? [
              _c(
                "ul",
                { staticClass: "search_results" },
                _vm._l(_vm.paginatedData, function (post, index) {
                  return _c("li", { key: index }, [
                    post.title
                      ? _c("h3", {
                          domProps: { innerHTML: _vm._s(post.title) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    post.excerpt
                      ? _c("p", {
                          domProps: { innerHTML: _vm._s(post.excerpt) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cta_wrapper" },
                      [
                        post.post_type_slug != "benefit_coverage"
                          ? [
                              post.permalink
                                ? _c("tertiary-button", {
                                    attrs: {
                                      label: "Visit " + post.post_type,
                                      link: {
                                        title: post.title,
                                        target: "_self",
                                        url: post.permalink,
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        post.post_type_slug === "benefit_coverage"
                          ? _vm._l(
                              post.coverage_options,
                              function (cover, index) {
                                return _c("tertiary-button", {
                                  key: index,
                                  attrs: {
                                    label: "Visit " + cover.title,
                                    link: {
                                      title: cover.title,
                                      target: "_self",
                                      url: cover.permalink,
                                    },
                                  },
                                })
                              }
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                }),
                0
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.busy != true && _vm.paginatedData.length === 0
          ? _c("div", { staticClass: "no_posts" }, [
              _c("div", {
                staticClass: "no_posts_message",
                domProps: { innerHTML: _vm._s(_vm.no_posts_message) },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "no_posts__cta_container" },
                [
                  _vm.parsedPrimaryCta
                    ? _c("primary-button", {
                        attrs: {
                          label: _vm.parsedPrimaryCta.title,
                          link: _vm.parsedPrimaryCta,
                          theme: "light",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.parsedSecondaryCta
                    ? _c("secondary-button", {
                        attrs: {
                          label: _vm.parsedSecondaryCta.title,
                          link: _vm.parsedSecondaryCta,
                          theme: "dark",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.pageCount != 1 && _vm.paginatedData.length != 0 && _vm.busy != true
          ? _c(
              "ul",
              { staticClass: "page-numbers" },
              [
                _vm.pageNumber != 0
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "prev page-numbers",
                          on: {
                            click: function ($event) {
                              _vm.pageNumber--
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "arrow_container" },
                            [_c("chevron-right")],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Previous")]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.pageCount, function (post, index) {
                  return _c("li", { key: index }, [
                    _c("a", {
                      staticClass: "page-numbers",
                      class: { current: index == _vm.pageNumber },
                      domProps: { innerHTML: _vm._s(index + 1) },
                      on: {
                        click: function ($event) {
                          _vm.pageNumber = index
                        },
                      },
                    }),
                  ])
                }),
                _vm._v(" "),
                _vm.pageNumber != _vm.pageCount - 1
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "next page-numbers",
                          on: {
                            click: function ($event) {
                              _vm.pageNumber++
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("Next")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "arrow_container" },
                            [_c("chevron-right")],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }